import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
    AuditItem,
    IPortfolioResultResponse
} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';
import {IrbEditorPortfolioResultService} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.service';
import {catchError, map, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {UtilityService} from '@irb-common/services/utility.service';
import {AuthService} from '@irb-common/services/auth.service';
import {IRebalResponseObject} from '@irb/irb-rebalance/results/results.model';
import {IrbModelsEvents} from '@irb/irb-models/irb-models.events';
import {AppService} from '@irb/app.service';
import {IrbAgGridExportService} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';

interface ISecurityUsageData {
    relatedAs: string;
    relatedToDesc: string;
    relatedToName: string;
    securitySymb: string;
}

@Component({ standalone: false,
    selector: 'irb-dialog-show-security-usage-warning',
    templateUrl: './dialog-show-security-usage-warning.component.html',
    styleUrls: ['./dialog-show-security-usage-warning.component.scss']
})


export class DialogShowSecurityUsageWarningComponent implements OnInit {

    isLoading: boolean;
    continueToAddSecuritiesToGrid: Function;
    private securitiesAffected: number;
    private affectedPortfolios: number;
    gridData$: MatTableDataSource<ISecurityUsageData>;
    private exportPayload: string = '';
    private strGridData: string = '';
    data: {securityIdArray: Array<Number>, response: IRebalResponseObject};
    private exportFileName = 'deleteOrMoveSecuritiesExport';

    columns = ['securitySymb', 'noLongerBe', 'forThisOther'];
    columnHeaders = ['Security', 'Will no longer be', 'For this OTHER security/portfolio'];
    isUnitTest: boolean = false;

    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private dialogRef: MatDialogRef<DialogShowSecurityUsageWarningComponent>,
        private portfolioService: IrbEditorPortfolioResultService,
        private utilityService: UtilityService,
        private authService: AuthService,
        public as: AppService,
        @Inject(MAT_DIALOG_DATA) public csd: any,
        public ges: IrbAgGridExportService
    ) {
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.data = this.csd.data || null;
        this.continueToAddSecuritiesToGrid = this.csd.continueToAddSecuritiesToGrid || null;
        this.getGridData();

    }

    getGridData() {
        const tempDataList: any[] = [];
        this.data.securityIdArray.forEach((id) => {
            const secId = id.toString();
            this.data.response.responseData[secId].forEach((item: ISecurityUsageData) => {
                item.relatedToName = item.relatedToName + " " + item.relatedToDesc;
                this.strGridData += item.securitySymb + ',' + item.relatedAs + ',' + item.relatedToName + '\n';
                tempDataList.push(item);
            });
        });
        this.gridData$ = new MatTableDataSource(tempDataList);
        this.isLoading = false;
    }

    getHeaderMessage(): string {
        let headerMessage: string = "";
        this.affectedPortfolios = this.data.response?.responseUtilityMap?.records?.affectedPortfolios;
        this.securitiesAffected = this.data.response?.responseUtilityMap?.records?.securitiesAffected;
        const securityLabel = this.securitiesAffected === 1 ? "security" : "securities";
        const portfolioLabel = this.affectedPortfolios === 1 ? "portfolio" : "portfolios";
        if (this.securitiesAffected > 0 && this.affectedPortfolios > 0) {
            headerMessage = this.securitiesAffected + " OTHER " + securityLabel + "or" + this.affectedPortfolios + " " + portfolioLabel
                + " will lose some specified usage rules";
        } else if (this.securitiesAffected > 0) {
            headerMessage += this.securitiesAffected + " OTHER " + securityLabel;
        } else if (this.affectedPortfolios > 0) {
            headerMessage += this.affectedPortfolios + " " + portfolioLabel;
        }
        headerMessage += " will lose some specified usage rules";
        return headerMessage;
    }

    close() {
        this.dialogRef.close();
    }

    continue() {
        this.continueToAddSecuritiesToGrid();
        this.close();
    }

    export() {
        this.exportPayload += this.columnHeaders[0] + ',' + this.columnHeaders[1] + ',' + this.columnHeaders[2] + '\n';
        this.exportPayload += this.strGridData;
        this.ges.setPrefix(this.exportFileName, "csv");
        const blob = new Blob([this.exportPayload]);
        this.ges.download(blob);
    }
}
